import { render, staticRenderFns } from "./CreateProductsView.vue?vue&type=template&id=17323f8e"
import script from "./CreateProductsView.vue?vue&type=script&lang=js"
export * from "./CreateProductsView.vue?vue&type=script&lang=js"
import style0 from "./CreateProductsView.vue?vue&type=style&index=0&id=17323f8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports